import { LOSCollapseList } from '@exam-management/los-list';
import { Box, PaperSection } from '@shared/components';

export default function LOSListPage() {
  return (
    <Box sx={(theme) => ({ p: theme.spacing(6) })}>
      <PaperSection title='วัตถุประสงค์การเรียนรู้ (Learning Objective Statement (LOS))'>
        <Box sx={(theme) => ({ p: theme.spacing(6) })}>
          <LOSCollapseList />
        </Box>
      </PaperSection>
    </Box>
  );
}
